import React, { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../../../hooks/useAuth";
import { BASE_URL } from "../../../../utils/Element";
import Modal from "../../../../components/Modal/Modal";
import { NotificationManager } from "react-notifications";
import Select from "react-select";

const AddLeadRoundRobinModal = ({ showModal, onClose, onCallApi, totalItems }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [users, setUsers] = useState([]);
  const [data, setData] = useState({
    user_id: "",
  });

  useEffect(() => {
    if (showModal && users.length === 0) {
      // Fetch users for dropdown
      axios
        .get(`${BASE_URL}/get-datalisting?list=users`, config)
        .then((res) => {
          if (res?.data?.success) {
            setUsers(res.data.data);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [showModal]); 

  const userOptions = users.map((user) => ({
    value: user.id,
    label: `${user.first_name} ${user.last_name} (${user.name})`
  }));

  const handleChange = (value, name) => {
    setError({ ...error, [name]: "" });
    setData({ ...data, [name]: value });
  };

  const handleClose = () => {
    onClose();
    setDisable(false);
    setError();
    setData({
      user_id: "",
    });
  };

  const handleSubmit = (e) => {
    setDisable(true);
    e.preventDefault();
    const dataToSend = {
      user_id: data.user_id,
      position: totalItems ? totalItems + 1 : 1, // Go to the bottom of the list
    };

    axios
      .post(`${BASE_URL}/add-round-robin`, dataToSend, config)
      .then((res) => {
        onCallApi();
        handleClose();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => {
        setDisable(false);
      });
  };

  return (
    <Modal title="Add Lead Round Robin" desc={""} show={showModal} onClose={handleClose}>
      <form className="mt-3" onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="dark-H head-4 mb-2 required:*:">
            Select User
            <span className="red-D">*</span>
          </label>
          <Select
            className="body-N w-full capitalize"
            options={userOptions}
            value={userOptions.find(opt => opt.value === data.user_id) || null}
            onChange={(selectedOption) => handleChange(selectedOption ? selectedOption.value : "", "user_id")}
            menuPlacement="bottom"
            placeholder="Select User"
            isClearable
          />
          {error?.user_id && <span className="body-S red-D">{error?.user_id}</span>}
        </div>

        <div className="mt-8">
          <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
            Add
          </button>
          <button type="button" onClick={handleClose} className="green-H ml-5">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddLeadRoundRobinModal;
